import React from 'react'
import type { ICellRendererParams } from 'ag-grid-community'
import { Horizontal, Vertical, Texto, MaterialIcon } from '@gravitate-js/excalibrr'
import type { Match } from '../../../../../../api/useSupplierReconciliation/types/match'

const PoNumber = ({ poNumber }: { poNumber: string }) => {
  return <span>{poNumber}</span>
}

export function PoNumbersCellRenderer({ data }: ICellRendererParams<Match>) {
  const poNumbers = data?.po_numbers || []

  if (!poNumbers.length)
    return (
      <Horizontal verticalCenter style={{ overflow: 'visible' }} gap={4}>
        <MaterialIcon style={{ color: 'var(--theme-error)' }} icon='warning' />
        <Texto appearance='hint'>N/A</Texto>
      </Horizontal>
    )

  return (
    <Vertical justifyContent='center' style={{ gap: '4px', overflow: 'visible' }}>
      {poNumbers.map((poNumber, index) => (
        <PoNumber key={`${poNumber}-${index}`} poNumber={poNumber} />
      ))}
    </Vertical>
  )
}
